module.exports = __webpack_public_path__ + "static/media/Catalog_2025.83582874.pdf";